<template>
  <div class="add_cloud_email_container">
    <addCloud :class="$store.state.isLiteMode?'addDriveLiteMode':''" :style="{height: ($store.state.isLiteMode ? 'calc(100% - 90px)' : 'calc(100% - 320px)')}" />
    <addEmail v-if="!$store.state.isLiteMode" />
  </div>
</template>

<script>
import addCloud from '@/components/workspace/add_cloud';
import addEmail from '@/components/workspace/add_email';
export default {
  components: {
    addCloud,
    addEmail,
  },
  data: function () {
    return {
    };
  },
};
</script>

<style>
.add_cloud_email_container {
  height: 100%;
}

/* 云盘组件高度 */
.add_cloud_email_container #addClouds {
  height: calc(100% - 320px);
}

/* 云盘组件底部调整 */
.add_cloud_email_container #addClouds .cont-box {
  height: calc(100% + 8px);
}

.add_cloud_email_container #addClouds.addDriveLiteMode .cont-box {
  height: calc(100% - 29px);
}

/* 云盘组件不显示空白 */
.add_cloud_email_container #addClouds .selectInfo-footer {
  display: none;
}

/* 云盘 */
.add_cloud_email_container #addClouds .drive-add-cloud {
  width: 16%;
  height: 73px;
}

.add_cloud_email_container #addClouds .right-cont-body {
  height: calc(100% - 80px);
}

.widthNav2 .drive-add-cloud {
  width: 16%;
}

/* 企业云盘 */
.add_cloud_email_container #addClouds .drive-add-clouds-down {
  height: 170px;
}

.add_cloud_email_container #addClouds.addDriveLiteMode .drive-add-clouds-down {
  height: 220px;
}

/* 邮箱组件 */
.add_cloud_email_container #addEmails {
  height: 320px;
  z-index: 1;
}

.add_cloud_email_container #addEmails .cont-box {
  height: 200px;
}

/* 邮箱组件不显示标题 */
.add_cloud_email_container #addEmails .right-cont-middle {
  display: none;
}

/* 邮箱 */
.add_cloud_email_container #addEmails .drive-add-cloud {
  width: 15%;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/add_cloud_email.vue